import Statistics from "./Pages/Statistics";

const Routes = [Statistics];
const Widgets = [];

export default {
  Routes,
  Widgets,
};
